import {MatchInfoAction, MatchInfoState} from './types';
import {
  MATCHDETAIL_CLEANUP,
  MATCHINFO_BY_ID_GET_INVALIDATE,
  MATCHINFO_BY_ID_GET_REQUEST,
  MATCHINFO_BY_ID_GET_RESPONSE,
} from '../actionTypes';

const initialState: MatchInfoState = {
  isFetching: false,
  didInvalidate: false,
};

/**
 * Derives the 'detail' state by reducing a new one every time an involved action is dispatches.
 * If the action is not involved (meaning it's not related with this state), then the state
 * is not changed.
 * @param state
 * @param action
 */
const matchDetailReducer = (state: MatchInfoState = initialState, action: MatchInfoAction): MatchInfoState => {
  switch (action.type) {
    case MATCHINFO_BY_ID_GET_REQUEST:
      return ({
        ...state,
        isFetching: true,
        error: undefined,
      });
    case MATCHINFO_BY_ID_GET_RESPONSE:
      return ({
        ...state,
        isFetching: false,
        didInvalidate: false,
        data: action.payload.match,
      });
    case MATCHINFO_BY_ID_GET_INVALIDATE:
      return ({
        ...state,
        isFetching: false,
        didInvalidate: true,
        error: action.error,
      });
    case MATCHDETAIL_CLEANUP:
      return ({...initialState});
    default:
      return state;
  }
};

export default matchDetailReducer;
